export const REGEX = {
  CHECK_NUMBER: /.*[0-9].*/,
  CHECK_WHOLE_NUMBER: /^(0|[1-9]\d*)$/,
  CHECK_OTP: /^[0-9]{6}$/,
  CHECK_SPACES: /^\S*$/,
  CHECK_UPPERCASE: /[A-Z]/,
  CHECK_LOWERCASE: /[a-z]/,
  CHECK_SYMBOL: /.*[!@#$%^&+=*].*/,
  EMAIL:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/,
  PHONE: /^\+1[-.\s]?(?:\(?\d{3}\)?[-.\s]?|\d{3}[-.\s]?)(\d{3})[-.\s]?(\d{4})$/,
  NOT_NUMBER: /[^\d]/g,
  IMAGE_TYPE: /(jpeg|jpg|png)$/i,
  PROOF_TYPE: /(jpeg|jpg|png|pdf)$/i,
  DOCUMENT_TYPE: /(jpeg|jpg|png|pdf|gif)$/i,
  PERCENTAGE: /(\d{0,3})[^.]*((?:\.\d{0,2})?)/,
  DECIMAL_NUMBER: /^\d+(\.\d{1,2})?$/,
  CURRENCY_VALUE: /^[0-9]+(\.[0-9][0-9])?$/,
  CHECK_ASTERISK: /\*/g,
  CHECK_URL:
    /^(http(s):\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/,
  LOCALHOST:
    /(?:^|[ \t])((https?:\/\/)?(?:localhost|[\w-]+(?:\.[\w-]+)+)(:\d+)?(\/\S*)?)/i,
  HEX_COLOR: /^#([A-Fa-f0-9]{6})$/,
  CAMEL_CASE_WORD_BOUNDARIES: /(?:^\w|[A-Z]|\b\w)/g,
  WHITESPACE: /\s+/g,
  SSN: /^(?!000|666|9\d{2})(\d{3})(-?)(?!00)\d{2}\2(?!0000)\d{4}$/,
  // Supports 5-34 alphanumeric characters. IBAN.
  CHECK_ACCOUNT_NUMBER: /^[a-zA-Z0-9]{5,34}$/,
  // US Routing Number is 9 digits only
  CHECK_US_ROUTING_NUMBER: /^\d{9}$/,
  // If 8 or 11 digits is given, we assume must be SWIFT/BIC so format looks generally like a SWIFT/BIC number (alphanumeric)
  CHECK_SWIFT_BIC_ROUTING_NUMBER:
    /^(?!\d{9}$)[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}(?:[A-Z0-9]{3})?$/,
};
